// eslint-disable-next-line import/prefer-default-export
export enum Types {
  QA = 'Q&A',
  CLIP = 'Clip',
  PHOTO = 'Photo',
}
